import maintenanceAnimation from "assets/animations/maintenance_animation.lottie?url";

import ErrorElements, { TITLES } from "../ErrorElements";

const Maintenance = () => {
    const animationCSS: object = {
        height: "250px",

        "@media (max-width: 839px)": {
            height: "160px"
        },

        "@media (max-width: 599px)": {
            height: "140px"
        }
    };

    return (
        <ErrorElements
            title={TITLES.Maintenance}
            animation={maintenanceAnimation}
            animationCSS={animationCSS}
        />
    );
};

export default Maintenance;
